<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :load_url="load_url"
            :icons="icon_data"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysOfferResults',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            width: {type:Number, default: 25},
        },
        data() {
            return {
                main_icon: 'fa-light fa-file-check',
                title: 'Today\'s Offer Result',
                load_url: '/dashboards/TotalOfferResults/',
                icon_data: [
                    {
//                        name: 'Offer Accepted',
                        name: 'Accepted',
                        text_color: '#264653',
                    },
                    {
//                        name: 'Offer Declined',
                        name: 'Declined',
                        text_color: '#E76F51',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>